import React, { useState } from "react";
import { Copy, Check, KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const TempPasswordDialog = ({ result, onClose }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(result.temp_password);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (_) {}
  };
  return (
    <Dialog open={Boolean(result)} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass-dark border border-red-500/30 text-white" data-testid="temp-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <KeyRound size={18} className="text-red-400" /> Temporary password
          </DialogTitle>
          <DialogDescription className="text-zinc-400">
            Share this with <span className="text-white">{result?.email}</span> (e.g. via Discord DM).
            They'll be asked to set a new password on their next login. It won't be shown again.
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center gap-2 mt-2">
          <code data-testid="temp-password-value"
            className="flex-1 px-4 py-3 rounded-xl bg-black/60 border border-white/10 font-mono text-lg tracking-wider select-all">
            {result?.temp_password}
          </code>
          <button onClick={copy} data-testid="temp-password-copy" className="btn-liquid !py-3">
            {copied ? <Check size={14} /> : <Copy size={14} />} {copied ? "Copied" : "Copy"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
